import {styledByTheme} from "../../../themes/architecture/styled-by-theme";
import {ClockLastLoginDefaultBox} from "./clock-last-login.default.box";
import {ClockLastLoginCasino777Box} from "./clock-last-login.casino777.box";

export const ClockLastLoginBox = styledByTheme(ClockLastLoginDefaultBox).forCasino777(ClockLastLoginCasino777Box).apply();
